<template>
  <div class="title-warp">
    <div class="title-box">
      <h3>{{title}}</h3>
    </div>
  </div>
</template>

<script>
  export default {
    name: "TopTitle",
    props: ['title']
  }
</script>

<style scoped lang="less">
  .title-warp {
    position: relative;
    height: 260px;
    background-image: linear-gradient(180deg, #090D35 0%, #0D74B3 100%);
    .title-box {
      width: 1000px;
      margin: 0 auto;
      height: 100%;
      position: relative;
    }
    h3 {
      position: absolute;
      top: 112px;
      left: 30px;
      font-size: 24px;
      color: #fff;
      font-weight: normal;
    }
  }

</style>